export default "__VITE_ASSET__a27e11da__"